window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
	/**
	* Browser cookies are required to use the cart. This function checks if
	* cookies are enabled in the browser.
	*/
	cookiesEnabled: function() {
		var cookieEnabled = navigator.cookieEnabled;
		
		if (!cookieEnabled)	{
			document.cookie = 'testcookie';
			cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
		}
		return cookieEnabled;
	},
	
	
	clickedMinus: function(el) {
		var line = el.data('line');
		var input = $("[lineid="+line+"]");
		var val = ~~input.attr('value');
		val = (val > 0) ? val-1 : val;
		if (!val) return;
		input.attr('value', val);
		$('[name="update"]').trigger('click');
	},
	
	
	clickedPlus: function(el) {
		var line = el.data('line');
		var input = $("[lineid="+line+"]");
		var val = ~~input.attr('value')+1;
		$(input).attr('value', val);
		$('[name="update"]').trigger('click');
	},
	
	
	/**
	 * Cart functions to update the cart 
	 * on quantity change
	*/
	cartUpdates: function() {
		var $minus = $('.btn-minus');
		var $plus = $('.btn-plus');
		
		$minus.on('click', function(e) { slate.cart.clickedMinus($(this)) });
		$plus.on('click', function(e) { slate.cart.clickedPlus($(this)) });
	}
};
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="banner-video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {
	/**
	* Preloads an image in memory and uses the browsers cache to store it until needed.
	*
	* @param {Array} images - A list of image urls
	* @param {String} size - A shopify image size attribute
	*/
	
	function preload(images, size) {
		if (typeof images === 'string') {
			images = [images];
		}
	
		for (var i = 0; i < images.length; i++) {
			var image = images[i];
			this.loadImage(this.getSizedImageUrl(image, size));
		}
	}
	
	/**
	* Loads and caches an image in the browsers cache.
	* @param {string} path - An image url
	*/
	function loadImage(path) {
		new Image().src = path;
	}
	
	/**
	* Find the Shopify image attribute size
	*
	* @param {string} src
	* @returns {null}
	*/
	function imageSize(src) {
		var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
	
		if (match) {
			return match[1];
		} else {
			return null;
		}
	}
	
	/**
	* Adds a Shopify size attribute to a URL
	*
	* @param src
	* @param size
	* @returns {*}
	*/
	function getSizedImageUrl(src, size) {
		if (size === null) {
			return src;
		}
	
		if (size === 'master') {
			return this.removeProtocol(src);
		}
		
		var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
		
		if (match) {
			var prefix = src.split(match[0]);
			var suffix = match[0];

			return this.removeProtocol(prefix[0] + suffix);
			//return this.removeProtocol(prefix[0] + '_' + size + suffix);
		} else {
			return null;
		}
	}
	
	function removeProtocol(path) {
		return path.replace(/http(s)?:/, '');
	}
	
	return {
		preload: preload,
		loadImage: loadImage,
		imageSize: imageSize,
		getSizedImageUrl: getSizedImageUrl,
		removeProtocol: removeProtocol
	};
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    
    // ADD abilities for alternate selects
    this._alternatSelector();
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
    
    /**
     * Alternate design option to select. Event handler (on.click)
     *
     * @param  {string} Target selector ID: singleOptionSelector
     */
     _alternatSelector: function() {
	    $('[data-alternate-select]', this.$container).on('click', 'a', function(e) {
		   e.preventDefault();
		   var $this = $(this);
		   var $parent = $this.parents('ul');
		   var $target = $parent.attr('data-select-target');
		   var value = $this.attr('data-option');
		   if (!$target || !value) return;
		   
		   $parent.find('li').removeClass('selected');
		   $this.parents('li').eq(0).addClass('selected');
		   $('#'+$target).val(value).trigger('change');
	     });
     }
  });

  return Variants;
})();

/**
 * Filter  Script
 * ------------------------------------------------------------------------------
 * Will triggers <select> changes on collection and cart pages.
 *
 * @namespace filters
 */
 
theme.Filters = (function() {
	var constants = {
		SORT_BY: 'sort_by'
	};
	var selectors = {
		filterSelection			: '[filters-filter]',
		sortSelection			: '[filters-sort]',
		defaultSort				: '[filters-default-sort]'
	};
	
	/**
	 * Filters constructor. 
	 * @param {string} container - selector for the section container DOM element
	 */
	function Filters(container) {
		this.$container = this.$container = $(container);

	    this.$filterSelect = $(selectors.filterSelection, this.$container);
	    this.$sortSelect = $(selectors.sortSelection, this.$container);
	    this.$selects = $(selectors.filterSelection, this.$container).add($(selectors.sortSelection, this.$container));
	
	    this.defaultSort = this._getDefaultSortValue();
	    this.$selects.removeClass('hidden');
	
	    this.$filterSelect.on('change', this._onFilterChange.bind(this));
	    this.$sortSelect.on('change', this._onSortChange.bind(this));
	}
	
	
	Filters.prototype = $.extend({}, Filters.prototype, {
		_onSortChange: function(evt) {
			var sort = this._sortValue();
			if (sort.length) {
				window.location.search = sort;
			} else {
				// clean up our url if the sort value is blank for default
				window.location.href = window.location.href.replace(window.location.search, '');
			}
		},
		
		_onFilterChange: function(evt) {
			window.location.href = this.$filterSelect.val() + window.location.search;
		},
		
		_getSortValue: function() {
			return this.$sortSelect.val() || this.defaultSort;
		},
		
		_getDefaultSortValue: function() {
			return $(selectors.defaultSort, this.$container).val();
		},
		
		_sortValue: function() {
			var sort = this._getSortValue();
			var query = '';
		
			if (sort !== this.defaultSort)
				query = constants.SORT_BY + '=' + sort;
				
			return query;
		}
	});
	
	return Filters;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */
theme.Product = (function() {
	var selectors = {
		addToCart: '[data-add-to-cart]',
		addToCartText: '[data-add-to-cart-text]',
		comparePrice: '[data-compare-price]',
		comparePriceText: '[data-compare-text]',
		originalSelectorId: '[data-product-select]',
		priceWrapper: '[data-price-wrapper]',
		productFeaturedImage: '[data-product-featured-image]',
		productImageWraps: '[data-image-wrapper]',
		productJson: '[data-product-json]',
		productPrice: '[data-product-price]',
		productThumbs: '[data-product-single-thumbnail]',
		singleOptionSelector: '[data-single-option-selector]'
	};
	/**
	 * Product section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */

	function Product(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');
		this.settings = {};
		this.namespace = '.product';
		this.zoomWrapper = $(selectors.productImageWraps);
		
		// Stop parsing if we don't have the product json script tag when loading
		// section in the Theme Editor
		if (!$(selectors.productJson, this.$container).html()) { return; }
		
		this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
		this.zoomEnabled = this.$container.attr('data-zoom-enabled');
		
		this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));
		slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
		
		this.initVariants();
		this.ShowImg();
		
		// Zoom On Desktop only
		//var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		//if (w > 1024)
		this.initZoom();
	}
	
	Product.prototype = $.extend({}, Product.prototype, {
		/**
		 * Handles change events from the variant inputs
		*/
		initVariants: function() {
			var options = {
				$container: this.$container,
				enableHistoryState: this.$container.data('enable-history-state') || false,
				singleOptionSelector: selectors.singleOptionSelector,
				originalSelectorId: selectors.originalSelectorId,
				product: this.productSingleObject
			};
			this.variants = new slate.Variants(options);
			this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
			this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
			this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
		},
		
		ShowImg: function() {
			this.zoomWrapper.map(function(i, el) {
				$(el).find('img').map(function(j, img) {
					$(img).on('load', function() {
						setTimeout(function() {
							var $img = $(img);
							$img.addClass('on');	
						}, 1);	
					}).each(function() {
						if(this.complete)
							$(this).trigger('load');
					});	
				});
				
			});
		},
		
		/**
		 * Add zoom functions on images
		 */
		initZoom: function() {	
			// destroy image zooming if enabled
			if (this.zoomEnabled) {
				$(this.zoomWrapper).each(function( index ) {
					_destroyZoom(this);
				});
			}
			
			if (this.zoomEnabled) {
				$(this.zoomWrapper).each(function( index ) {
					_enableZoom(this);
				});
			}
		},
		
		/**
		 * Updates the DOM state of the add to cart button
		 *
		 * @param {boolean} enabled - Decides whether cart is enabled or disabled
		 * @param {string} text - Updates the text notification content of the cart
		 */
		updateAddToCartState: function(evt) {
			var variant = evt.variant;
			if (variant) {
				$(selectors.priceWrapper, this.$container).removeClass('visually-hidden');
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
				$(selectors.priceWrapper, this.$container).addClass('visually-hidden');
				return;
			}
			if (variant.available) {
				$(selectors.addToCart, this.$container).prop('disabled', false);
				$(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
			}
		},
		
		/**
		 * Updates the DOM with specified prices
		 *
		 * @param {string} productPrice - The current price of the product
		 * @param {string} comparePrice - The original price of the product
		 */
		updateProductPrices: function(evt) {
			var variant = evt.variant;
			var $comparePrice = $(selectors.comparePrice, this.$container);
			var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
			$(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
			if (variant.compare_at_price > variant.price) {
				$comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
				$compareEls.removeClass('hide');
			} else {
				$comparePrice.html('');
				$compareEls.addClass('hide');
			}
		},
		
		/**
		 * Updates the DOM with the specified image URL
		 *
		 * @param {string} src - Image src URL
		 */
		updateProductImage: function(evt) {
			var variant = evt.variant;
			var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
			$(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
		},
		
		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function() {
			this.$container.off(this.namespace);
		}

	});
	
	/**
	 * Zoom functions
	 */
	function _enableZoom(el) {
		var zoomUrl = $(el).data('zoom');
		$(el).zoom({
			url: zoomUrl,
			touch: false
		});
	}
	
	function _destroyZoom(el) {
		$(el).trigger('zoom.destroy');
	}
	
	
	return Product;
})();
/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Colection(s) templates.
 *
 * @namespace collection
 */
 
theme.Collection = (function() {
	var selectors = {
		collectionImgWrapper: '[data-img-wrapper]',
		blockHeight: '[data-height]'
	};
	
	/**
	 * Collection section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function Collection(container) {
		var self = this;
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');
		this.settings = {};
		this.namespace = '.collection';
		this.imgWrappers = $(selectors.collectionImgWrapper);
	
		if (!this.imgWrappers)
			return;

		this.animateImg();
		
		$(window).on('resize', function () {
			self.animateImg();
		});
	}
	
	
	Collection.prototype = $.extend({}, Collection.prototype, {
		animateImg: function() {
			this.imgWrappers.map(function(i, el) {

				var h = 0;
				$(el).find('img').map(function(j, img) {
					$(img).on('load', function() {
						setTimeout(function() {
							if (j === 0) {
								var $img = $(img);
								h = $img.outerHeight();
								if (h) {
									$(el).parent().height(h);
									$(selectors.blockHeight).matchHeight();
									$img.addClass('on');
								}
							}
							if (j === 1) {
								$(img).css('display', 'block').addClass('on');
							}
						}, 1);
						
					}).each(function() {
						if(this.complete)
							$(this).trigger('load');
					});	
				});
				
			});
		}
	});
	
	return Collection;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
	var $newAddressForm = $('#AddressNewForm');
	if (!$newAddressForm.length) return;


	// Initialize observers on address selectors, defined in shopify_common.js
	if (Shopify) {
		new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
			hideElement: 'AddressProvinceContainerNew'
		});
	}

	// Initialize each edit form's country/province selector
	$('.address-country-option').each(function() {
		var formId = $(this).data('form-id');
		var countrySelector = 'AddressCountry_' + formId;
		var provinceSelector = 'AddressProvince_' + formId;
		var containerSelector = 'AddressProvinceContainer_' + formId;
		
		new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
			hideElement: containerSelector
		});
	});

	// Toggle new/edit address forms
	$('.address-new-toggle').on('click', function() {
		$newAddressForm.toggleClass('hide').find('.on-wrapper').delay('100').queue(function(next) {
			$(this).toggleClass('on');
			next();
		});
	});

	$('.address-edit-toggle').on('click', function() {
		var formId = $(this).data('form-id');
		$('#EditAddress_' + formId).toggleClass('hide').find('.on-wrapper').delay('100').queue(function(next) {
			$(this).toggleClass('on');
			next();
		});
	});

	$('.address-delete').on('click', function() {
		var $el = $(this);
		var formId = $el.data('form-id');
		var confirmMessage = $el.data('confirm-message');
		if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
			Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
		}
	});
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();



$(document).ready(function() {
	var sections = new slate.Sections();
	sections.register('product', theme.Product);
	sections.register('collection', theme.Collection);
	sections.register('collection', theme.Filters);
	
	// Common a11y fixes
	slate.a11y.pageLinkFocus($(window.location.hash));
	
	$('.in-page-link').on('click', function(evt) {
		slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
	});
	
	// Wrap videos in div to force responsive layout.
	slate.rte.wrapTable();
	slate.rte.iframeReset();
	
	// Cart update btns
	slate.cart.cartUpdates();
	
	// Apply a specific class to the html element for browser support of cookies.
	if (slate.cart.cookiesEnabled()) {
		document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
	}
	
	// Image preloading
	if (theme._images2Preload.length)
		slate.Image.preload(theme._images2Preload, theme._images2PreloadSize);
});

//================ THEME =============== //
theme.selectors = function() {
	theme.cache = {
		$body					: $('html,body'),
		$ie9					: $('.ie9'),
		$menu					: $('#menu'),
		$pageSubMenu			: $('.page-sub-menu'),
		$toScroll				: $('[data-to-scroll]'),
		$heroHome				: $('.template-index .hero'),
		$newsletterFormBtn		: $('#newsletter button'),
		$newsletterInput		: $('#newsletter input'),
		$historicPhoto			: $('.historic .photo'),
		$campaignPhoto			: $('.campaign .photo'),
		$campaigns				: $('#campaigns'),
		$campaignsLinks			: $('#campaigns .campaigns-menu a'),
		$campaignSections		: $('#campaigns .shopify-section'),
		$press					: $('.press'),
		$flyNav					: $('.blog .fly-nav'),
		mediaType				: null,
		threeActive				: false
	};
}


theme.init = function() {
	theme.selectors();
	theme.mediaQuery('screen and (max-width:1023px)');
	theme.menu();
	theme.menuActive();
	theme.windowResize();
	theme.brandMenu();
	theme.toScroll();
	theme.campaignViewMore(theme.cache.$historicPhoto);
	theme.campaignViewMore(theme.cache.$campaignPhoto);
	theme.newsletter();
	theme.campaignMenu();
	theme.pressViewMore();
	theme.contactPartnerPage();
	theme.contactCheckInfo();
	theme.ie9();
	theme.iosBadVH();
	theme.heroVideo();
}


theme.heroVideo = function() {	
	var loop = 1;
	if ( theme._heroHomeMp4 && theme._heroHomeWebm ) {
		var index_mp4 = theme._heroHomeMp4.indexOf('?');
		var index_webm = theme._heroHomeWebm.indexOf('?');
		if (index_mp4 != -1)
			theme._heroHomeMp4 = theme._heroHomeMp4.substring(0, index_mp4);
		if (index_webm != -1)
			theme._heroHomeWebm = theme._heroHomeWebm.substring(0, index_webm);
		
		var backgroundVideo = new BackgroundVideo('#heroVideo', {
			src: [theme._heroHomeMp4, theme._heroHomeWebm],
			onReady: function () { 
				backgroundVideo.el.play();
				
				// Mute Btn
				var $btnVolume = $('#muteBtn');
				$btnVolume.on('click', function(e) {
					e.preventDefault();
					var state = backgroundVideo.el.muted;
					if (!state) {
						$(this).removeClass('fa-volume-up');
						$(this).addClass('fa-volume-off');
					} else {
						$(this).addClass('fa-volume-up');
						$(this).removeClass('fa-volume-off');
					}
					backgroundVideo.el.muted = !state;
				});
				
				// Create loop and mute
				$(backgroundVideo.el).on('ended', function() {			
					if (loop--) {
						// replay the video
						//console.log('ENDED');
						backgroundVideo.el.muted = true;
					}
					// Loop
					backgroundVideo.el.play();
				});
				
			}			
		});
		
		// For ios
		if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
			backgroundVideo.el.autoplay = true;
		}
	}
}


theme.ie9 = function() {
	if (theme.cache.$ie9.length)
		$('input, textarea').placeholder();
}


theme.iosBadVH = function() {
	// fix iOS bug in CSS vh
	// https://gist.github.com/pburtchaell/e702f441ba9b3f76f587
	var isBadIos = function() {
	    var regex = /(iPhone|iPad|iPod);[^OS]*OS (\d)/;
	    var matches = navigator.userAgent.match(regex);
	    if (!matches) return false;
		    return matches[2] < 8;
	}
	
	if (isBadIos()) {
		var h = document.documentElement.clientHeight || 0;
		if (h) theme.cache.$heroHome.height(h+1);
	}
}


theme.windowResize = function() {
	$(window).on('resize', function () {
		theme.threeRowOrder();
	});
}


theme.update = function(msg) { theme.cache.mediaType = msg }


theme.mediaQuery = function(condition) {
	Harvey.attach(condition, {
		on: function() {
			theme.cache.mediaType = 'mobile';
			theme.threeRowOrder();
			theme.campaignViewMore(theme.cache.$historicPhoto);
			theme.campaignViewMore(theme.cache.$campaignPhoto);
		},
		off: function() {
			theme.cache.mediaType = 'desktop';
			theme.campaignViewMore(theme.cache.$historicPhoto);
			theme.campaignViewMore(theme.cache.$campaignPhoto);
		}
	});
}


theme.toScroll = function() {
	theme.cache.$toScroll.on('click', function(e) {
		var h = e.currentTarget.hash || null;
		var s = $(this).attr('data-scroll-speed') || null;
		if (h) {
			e.preventDefault();
			theme.scroller(h, s);
		}
	});
}


theme.scroller = function(hash, duration, cb) {
	var target = $(hash)
	dur = duration || 800;

	if (target.length) {
		theme.cache.$body.animate({
			scrollTop: target.offset().top - theme.cache.$menu.height()
		}, dur, 'easeInCubic')
		.promise().done(cb);
	}
	return false;
}


theme.brandMenu = function() {
	theme.cache.$pageSubMenu.on('click', 'a', function(e) {
		if (this.hash == '#campaigns') {
			e.preventDefault();
			theme.scroller(this.hash, 1000);
		}
	});
}


theme.menu = function() {
	// Add _target to instagran in top menu
	theme.cache.$menu.find('.nav a').last().attr('target', '_blank');
	theme.cache.$menu.on('shown.bs.collapse', '.navbar-collapse', function() {
		if (theme.cache.mediaType && theme.cache.mediaType === 'mobile')
			theme.cache.$menu.addClass('menuopen');
	});
	theme.cache.$menu.on('hide.bs.collapse', '.navbar-collapse', function() {
		theme.cache.$menu.removeClass('menuopen');
	});
}


theme.menuActive = function() {
	var didScroll = false,
		changeHeaderOn = 40,
		flyNavBottom = (theme.cache.$flyNav.length) ? $('.article .content .rte').height() : null;
		
	function run() {
		window.addEventListener('scroll', function(event) {
			if( !didScroll ) {
				didScroll = true;
				setTimeout(scrollPage, 1);
			}
		}, false);
	}
	
	function scrollPage() {
		var sy = scrollY();
		if (sy >= changeHeaderOn)
			theme.cache.$body.addClass('menu-active');
		else
			theme.cache.$body.removeClass('menu-active');
		didScroll = false;
		
		// Fly Nav
		if (!theme.cache.$flyNav.length) return;
		
		if (sy >= flyNavBottom)
			theme.flyNav(sy);
		else
			theme.flyNav(false);
	}

	function scrollY() {
		return window.pageYOffset || window.scrollTop;
	}
	
	run();
}


theme.flyNav = function(pos) {
	// console.log(pos);
	if (pos)
		theme.cache.$flyNav.css('opacity', 0);
	else 
		theme.cache.$flyNav.css('opacity', 1);
}


theme.threeRowOrder = function() {
	if (theme.cache.mediaType !== 'mobile' && theme.cache.$body.hasClass('template-index')) { 
		location.reload();
		return false;
	}
	var wrappers = $('.threearow .row');
	
	// For each wrapper
	wrappers.map(function(id, wrapper) {
		var	$wrapper = $(wrapper);
		vPosition = $wrapper.hasClass('vPostop') ? 'top' : 'bottom',
	    items = $wrapper.children('.photo'),
	    order = [],
	    biggerPos = 0;
	
	    // Look for bigger item position
	    items.map(function(index, item) {
		    if ($(item).hasClass('bigger'))
		    	biggerPos = index;
		    else
		    	order.push(index);
	    });
	    
	    // put the bigger image in the right position
	    // based on top | bottom position
	    if (vPosition === 'top')
	    	order.unshift(biggerPos);
	    else 
	    	order.push(biggerPos)
	    
		$wrapper.append(
			$.map(order, function(v) {
				return items[v];
			})
		);
	});
	theme.cache.threeActive = true;
}


theme.campaignViewMore = function(root) {
	// Clean html
	$(root).removeClass('nextSlider');
	root.off();
	$(root).parents('.row').find('section').remove();
	
	var target = (theme.cache.mediaType == 'mobile') ? 2 : 4;
	var $div = $("<section>", {"class": "col-xs-12 slider"});
	var elem, img, url, link, crop, idPhoto, clickedPhoto, self, len = root.length;
	
	root.map(function(i, el) {
		if (target == 2)
			if ((i % target-1 === 0) || (len % target && i==len-1))
				$(el).addClass('nextSlider');
		
		if (target == 4)
			if ((i % target === target-1) || (len % target && i==len-1))
				$(el).addClass('nextSlider');
		
	});
	
	root.on('click', function(e) {
		self = this;
		idPhoto = $(this).data('photo');
		
		if (clickedPhoto !== idPhoto) {
			$div.removeClass('on').delay(400).queue(function(next) {
				crop = $(self).find('.crop');
				url = crop.data('img');
				link = crop.data('link');
				img = document.createElement("IMG");
				img.src = url;
				img.className = 'img-responsive';
				
				// console.log($(self).nextAll('.nextSlider').addBack('.nextSlider'));
				
				elem = $(self).nextAll('.nextSlider').addBack('.nextSlider').eq(0).after($div).next('.slider');
				
				// link
				if (link)
					elem.html('<div class="hover-block"><div class="wrapper"><div class="inner"><div class="lips"></div></div></div></div><a href="'+link+'"></a>').find('a').html(img);
				else
					elem.html(img);
				
				elem.delay(20).queue(function(next) {
					$(this).addClass('on');
					next();
				});
				
				next();
			});	
		} else {
			$div.removeClass('on').delay(400).queue(function(next) {
				$div.empty();
				clickedPhoto = null;
				next();
			});
		}
		clickedPhoto = idPhoto;
	});
}


theme.pressViewMore = function() {
	var src, img, self, row, display, photoLarge, photoLargeHeight, originalHeight = 165;
	theme.cache.$press.on('click', '.link', function(e) {
		e.preventDefault();
		self = this;
		row = $(this).parents('.row');
		photoLarge = row.find('.photo-large');
		loading = row.find('.loading');
		display = row.find('.display');
		
		
		// reset / hide
		if (photoLarge.hasClass('opened')) {				
			photoLarge.css('height', ''); // reset to original height
			photoLarge.removeClass('open').delay(800).queue(function(next) {
				//photoLarge.removeClass('open');
				loading.removeClass('hidden');
				display.removeClass('on');
				photoLarge.removeClass('opened');
				next();
			});
		} else {
			// Show
			photoLarge.addClass('open');

			src = $(this).data('photo');
			img = document.createElement("IMG");
			img.src = src;
			img.className = 'img-responsive';
			
			$(img).on('load', function() {
				loading.delay(380).queue(function(next) {
					loading.addClass('hidden');
					next();
					display.html(img).delay(10).queue(function(next) {
						photoLargeHeight = $(img).height();
						display.addClass('on');
						photoLarge.animate({height: photoLargeHeight}, 200);
						photoLarge.addClass('opened');
						next();
					});
				});
			});
		}
				
	});
}


theme.campaignMenu = function() {
	theme.cache.$campaigns.on('click', '.campaigns-menu a', function() {
		if ($(this).hasClass('active')) return false;
		theme.cache.$campaignsLinks.map(function(i, el) {
			$(el).toggleClass('active');
		});
		
		theme.cache.$campaignSections.map(function(i, el) {
			$(el).toggleClass('on').delay(400).queue(function(next) {
				$(this).toggleClass('hidden');
				next();
			});
		});
	});
}


theme.contactPartnerPage = function() {
	if (!theme.cache.$body.hasClass('contactPartner')) return;
	var h = location.hash, allowed = ['#blogger', '#distributor', '#retailer', '#licensing'];
	if (h && (allowed.indexOf(h)) !== -1) {
		$('#ContactFormIAm').val(h.slice(1));
	}	
}


theme.contactCheckInfo = function() {
	// console.log($('#submitForm'));
	if (!theme.cache.$body.hasClass('contact') && !theme.cache.$body.hasClass('contactPartner')) return;
	var elems = $('#contact_form').find('input.required, textarea.required');
	
	$('#submitForm').on('click', function(e) {
		var errors = 0;
		elems.removeClass('err');

		elems.each(function(index, value) {
			if ( !$(this).val().length ) {
				errors++;
				$(this).addClass('err');
			}
		});
		if (errors)
			e.preventDefault();
	});
}


theme.newsletter = function() {
	theme.cache.$newsletterFormBtn.on('click', function(e) {
		var email = $('#mce-EMAIL').val();
		if (!email || email.length < 8 || (email.indexOf('@')<0)) {
			e.preventDefault();
			theme.cache.$newsletterInput.tooltip('show');
		}
	}).on('blur', function(e) {
		theme.cache.$newsletterInput.tooltip('hide');
	});
}


// Helper 
jQuery.extend(jQuery.easing, {
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	}
});


/** * INIT * **/
$(theme.init());